import { TaskContext } from "contexts/TaskDetailContext";
import { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { showError } from "../../redux/common/actions";
import { getModelTaskAttachments } from "services/models/modelDetails/modelTaskAttachments";
import { formatBytes, getFormattedLink } from "helpers/utils";
import ColourConstants from "helpers/colourConstants";
import { Link } from "@mui/material";
import { ModelContext } from "contexts/ModelDetailContext";

export default function useModelTaskAttachments({ taskInfo, isMounted }) {
	const [originalAttachments, setOriginalAttachments] = useState([]);
	const [attachments, setAttachments] = useState([]);
	const [loading, setLoading] = useState(true);
	// rdx hook
	const dispatch = useDispatch();
	// ctx
	const [, CtxDispatch] = useContext(TaskContext);
	const [state, MtxDispatch] = useContext(ModelContext);

	const fetchAttachments = async (showLoading = true) => {
		!isMounted.aborted && showLoading && setLoading(true);
		try {
			const response = await getModelTaskAttachments(taskInfo.id);
			if (response.status) {
				if (!isMounted.aborted) {
					setAttachments(
						response?.data?.map((a) => {
							return {
								...a,
								filesize: a.filesize > 0 ? formatBytes(a?.filesize) : " ",
								name: (
									<Link
										style={{ color: ColourConstants.activeLink }}
										href={
											a?.documentKey !== null
												? a?.documentURL
												: getFormattedLink(a?.link)
										}
										download={a?.name}
										target="_blank"
										rel="noopener"
									>
										{a?.name}
									</Link>
								),
							};
						})
					);
					setOriginalAttachments(
						response?.data?.map((a) => ({
							...a,
							filesize: formatBytes(a?.filesize),
							name: (
								<Link
									style={{ color: ColourConstants.activeLink }}
									href={a?.documentURL || a?.link}
									download={a?.name}
									target="_blank"
									rel="noopener"
								>
									{a?.name}
								</Link>
							),
						}))
					);
				}
				CtxDispatch({
					type: "TAB_COUNT",
					payload: {
						countTab: "documentCount",
						data: response?.data?.length,
					},
				});
				if (response.data.length > 0) {
					CtxDispatch({
						type: "SET_DOCUMENTS",
						payload: true,
					});
				} else {
					CtxDispatch({
						type: "SET_DOCUMENTS",
						payload: false,
					});
				}
			} else {
				dispatch(
					showError(
						response?.data?.title ||
							response?.data ||
							"Could not fetch task Attachments"
					)
				);
			}
		} catch (error) {
			dispatch(
				showError(
					error?.response?.data ||
						error?.response ||
						"Could not fetch task Attachments"
				)
			);
		} finally {
			!isMounted.aborted && showLoading && setLoading(false);
		}
	};

	useEffect(() => {
		fetchAttachments();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		CtxDispatch,
		MtxDispatch,
		attachments,
		fetchAttachments,
		loading,
		originalAttachments,
		setAttachments,
		setLoading,
		setOriginalAttachments,
		state,
	};
}
